import React from 'react';
import proptypes from 'prop-types';
const {
  node,
  bool,
  shape,
  arrayOf
} = proptypes;
import { GraphQLError } from 'graphql/error/GraphQLError';
import { InMemoryCache, disableFragmentWarnings } from '@apollo/client';
import { MockedProvider as ApolloMockedProvider, MockLink } from '@apollo/client/testing/testing.cjs.js';
import { typePolicies, dataIdFromObject } from "../react/util.js";
import possibleTypes from "../shapes/possibleTypes.js";
import { createMock, mockRequestResponse } from "./createMock.js";
const staticCache = new InMemoryCache({
  typePolicies,
  dataIdFromObject,
  possibleTypes,
  addTypename: false
});
const MockedProvider = props => {
  const defaultCache = new InMemoryCache({
    typePolicies,
    dataIdFromObject,
    possibleTypes,
    addTypename: false
  });

  // eslint-disable-next-line react/destructuring-assignment
  const cache = props.useStaticCache ? staticCache : defaultCache;
  disableFragmentWarnings();
  if (typeof window !== 'undefined' && window.__APOLLO_STATE__) {
    //eslint-disable-line
    cache.restore(window.__APOLLO_STATE__); //eslint-disable-line
  }
  const {
    children,
    addTypename,
    cache: paramsCache,
    mocks
  } = props;
  return /*#__PURE__*/React.createElement(ApolloMockedProvider
  // addTypename // do not add this field
  , {
    cache: paramsCache || cache,
    addTypename: addTypename,
    mocks: mocks
  }, children);
};
MockedProvider.propTypes = {
  children: node.isRequired,
  addTypename: bool,
  cache: shape({}),
  mocks: arrayOf(shape({})).isRequired,
  useStaticCache: bool
};
MockedProvider.defaultProps = {
  addTypename: false,
  cache: null,
  useStaticCache: true
};
export { MockedProvider, MockLink, createMock, mockRequestResponse, GraphQLError };
//# sourceMappingURL=index.js.map